import htmx from 'htmx.org';
import '../css/generated.css';

(window as any).htmx = htmx;
